import {
    createElement,
    forwardRef,
    PropsWithChildren,
    type CSSProperties,
} from 'react'

import classNames from 'classnames'

import { FlexOwnProps, FlexProps } from 'components/core/Flex/types'
import { addPxUnit } from 'components/core/helpers'

import * as flexStyles from './styles.module.scss'

function buildFlexStyle(props: FlexOwnProps): CSSProperties {
    const {
        alignItems,
        direction,
        gap,
        inline,
        justifyContent,
        margin,
        marginBottom,
        marginLeft,
        marginRight,
        marginTop,
        wrap,
    } = props

    const style: CSSProperties = {
        display: inline ? 'inline-flex' : 'flex',
    }

    if (alignItems) {
        style.alignItems = alignItems
    }
    if (direction) {
        style.flexDirection = direction
    }
    if (justifyContent) {
        style.justifyContent = justifyContent
    }
    if (wrap) {
        style.flexWrap = wrap
    }

    if (gap) {
        style.gap = addPxUnit(gap)
    }
    if (margin) {
        style.margin = margin
    }
    if (marginBottom) {
        style.marginBottom = addPxUnit(marginBottom)
    }
    if (marginLeft) {
        style.marginLeft = addPxUnit(marginLeft)
    }
    if (marginRight) {
        style.marginRight = addPxUnit(marginRight)
    }
    if (marginTop) {
        style.marginTop = addPxUnit(marginTop)
    }

    return style
}

const FlexComponent = forwardRef<any, PropsWithChildren<FlexProps<any>>>(
    (
        {
            children,
            className,
            component,
            style,
            alignItems,
            direction,
            gap,
            inline,
            justifyContent,
            margin,
            marginBottom,
            marginLeft,
            marginRight,
            marginTop,
            wrap,
            ...rest
        },
        ref
    ) => {
        const Tag = component ?? 'div'
        const flexStyle = buildFlexStyle({
            alignItems,
            direction,
            gap,
            inline,
            justifyContent,
            margin,
            marginBottom,
            marginLeft,
            marginRight,
            marginTop,
            wrap,
        })

        return createElement(
            Tag,
            {
                ref,
                ...rest,
                className: classNames(flexStyles.flexRoot, className),
                style: { ...flexStyle, ...style },
            },
            children
        )
    }
)

FlexComponent.displayName = 'Flex'
export default FlexComponent
